import type { NextraThemeLayoutProps } from 'nextra'
import DocsLayout, { useTheme as useNextTheme } from 'nextra-theme-docs'
import { FC, PropsWithChildren, useMemo } from 'react'
import ThemeCustomization from 'themes'

const Layout: React.FC<NextraThemeLayoutProps> = ({ children, ...context }) => {
	return (
		<DocsLayout {...(context as NextraThemeLayoutProps)}>
			<Wrapper>{children}</Wrapper>
		</DocsLayout>
	)
}

const Wrapper: FC<PropsWithChildren> = ({ children }) => {
	// const config = useConfig()
	const nextTheme = useNextTheme()

	const { resolvedTheme } = nextTheme
	const mode = useMemo<'dark' | 'light' | undefined>(() => {
		if (!resolvedTheme) return undefined // use default values
		switch (resolvedTheme?.toLowerCase()) {
			case 'dark':
				return 'dark'
			case 'light':
				return 'light'
			default:
				return undefined
		}
	}, [resolvedTheme])

	return <ThemeCustomization mode={mode}>{children}</ThemeCustomization>
}

export default Layout
